export default __webpack_public_path__ + "static/media/straw-avax.a9ae2651.png";